module.exports = __webpack_public_path__ + "static/media/nrkCRScz8g.c825dccc.jpg";